




























import Vue from 'vue'
import { FilterItem, DataTableColumnItem } from '@/models/dataTable'
import { DELETED_COLUMNS, RENAMED_COLUMNS } from '@/constants/dataTable'
import Search from '@/components/Search/Search.vue'
import DataTableSavedFilter from '@/components/DataTable/Filters/DataTableSavedFilters.vue'
import DataTableFilterItem from '@/components/DataTable/Filters/DataTableFilterItem.vue'
import CustomCheckbox from '@/components/Common/CustomCheckbox.vue'

interface FilterItemOption extends FilterItem {
  value: string
  filter: string
}

interface Props {
  columns: Array<DataTableColumnItem>
  filters: Record<string, string>
}

interface Data {
  searchValue: string
  activeFilters: string[]
  newFilters: Record<string, string>
}

interface Methods {
  toggleCheckbox: (key: string) => void
  filtered: (key: string) => void
  changeFilters: (value: FilterItemOption) => void
  isActive: (key: string) => boolean
  setActiveFilters: () => void
  filterName: (key: string) => string
  isVisible: (key: string) => boolean
}

interface Computed {
  deleteVoidColumns: Array<DataTableColumnItem>
  filteredColumns: Array<DataTableColumnItem>
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Search,
    DataTableSavedFilter,
    DataTableFilterItem,
    CustomCheckbox,
  },
  props: {
    columns: {
      required: true,
    },
    filters: {
      required: true,
    },
  },
  data() {
    return {
      searchValue: '',
      activeFilters: [],
      newFilters: {},
    }
  },
  methods: {
    toggleCheckbox(key: string) {
      if (!this.isActive(key)) {
        this.$delete(this.newFilters, key)
      }
      this.$emit('input', this.newFilters)
    },
    isActive(key) {
      return this.activeFilters.includes(key)
    },
    filtered(key: string) {
      if (this.isActive(key)) {
        this.activeFilters.splice(this.activeFilters.indexOf(key), 1)
      } else {
        this.activeFilters.push(key)
      }
    },
    changeFilters(value) {
      if (value.value.length === 0 && value.input !== 'none') {
        this.$delete(this.newFilters, value.filter)
      } else {
        this.$set(this.newFilters, value.filter, value.symbol + value.value)
      }
      this.$emit('input', this.newFilters)
    },
    setActiveFilters() {
      this.activeFilters = Object.keys(this.filters)
    },
    filterName(key) {
      let newKey = key
      if (RENAMED_COLUMNS.includes(key)) {
        newKey = DELETED_COLUMNS[RENAMED_COLUMNS.indexOf(key)]
      }
      return this.$tc('records.' + newKey)
    },
    isVisible(key) {
      return key !== 'id'
    },
  },
  computed: {
    deleteVoidColumns() {
      const newColumns = this.columns.filter(elem => {
        return !DELETED_COLUMNS.includes(elem.key)
      })
      return newColumns
    },
    filteredColumns() {
      if (this.searchValue) {
        return this.deleteVoidColumns.filter(elem => {
          return this.filterName(elem.key)
            .toLowerCase()
            .includes(this.searchValue.toLowerCase())
        })
      }
      return this.deleteVoidColumns
    },
  },
  mounted() {
    this.setActiveFilters()
    this.newFilters = Object.assign({}, this.filters)
  },
  watch: {
    '$route.query.filter'() {
      this.setActiveFilters()
      Object.keys(this.newFilters).forEach(elem => {
        if (!this.activeFilters.includes(elem)) {
          this.newFilters[elem]
          delete this.newFilters[elem]
        }
      })
    },
  },
})
